import { useState, type ReactNode } from 'react'
import { Check } from 'lucide-react'

export interface GuidedStepNav {
  next: () => void
  back: () => void
  restart: () => void
  isFirst: boolean
  isLast: boolean
}

export interface GuidedStep {
  label: string
  render: (nav: GuidedStepNav) => ReactNode
}

interface StageGuidedShellProps {
  steps: GuidedStep[]
}

export function StageGuidedShell({ steps }: StageGuidedShellProps) {
  const [step, setStep] = useState(0)

  function next() { setStep((s) => Math.min(steps.length - 1, s + 1)) }
  function back() { setStep((s) => Math.max(0, s - 1)) }
  function restart() { setStep(0) }

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        {steps.map((s, i) => (
          <div key={s.label} className="flex items-center gap-2 flex-1">
            <div className="flex items-center gap-2 flex-1">
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold shrink-0"
                style={i <= step ? { background: '#6366f1', color: 'white' } : { background: '#e5e7eb', color: '#64748b' }}
              >
                {i < step ? <Check size={12} /> : i + 1}
              </div>
              <span className="text-[11px] font-medium hidden sm:inline" style={{ color: i <= step ? '#4f46e5' : '#475569' }}>{s.label}</span>
            </div>
            {i < steps.length - 1 && <div className="h-[2px] flex-1" style={{ background: i < step ? '#6366f1' : '#e5e7eb' }} />}
          </div>
        ))}
      </div>

      {steps[step].render({ next, back, restart, isFirst: step === 0, isLast: step === steps.length - 1 })}
    </div>
  )
}
